const Spacer = () => {
  return (
    <div style={{ marginBottom: '42px' }} />
  );
};

export { Spacer };
